import { Component, OnInit } from '@angular/core';
import { AssignUser, guid, GUID } from './assign-user.model';
import { AssignUserRoleService } from './assign-user-role.service';
import { NgxSpinnerService } from 'ngx-spinner';
import { Router } from '@angular/router';
import { HttpClient } from '@angular/common/http';
import { environment } from '@environments/environment';
import { MessageService} from 'primeng/api';

@Component({
  selector: 'app-assign-user-role',
  templateUrl: './assign-user-role.component.html',
  styleUrls: ['./assign-user-role.component.css'],
  providers : [AssignUserRoleService]
})
export class AssignUserRoleComponent implements OnInit {
  usersWithStatusList: AssignUser[];
  usersWithRoleList : AssignUser[];
  userWithStatus: AssignUser = {
      userId : '', name : '', firstName : '' , lastName : '', isActive : false, selectedUser : ""
  };
  userWithRole: AssignUser = {
    userId : '', name : '',firstName : '' , lastName : '', isActive : true, selectedUser : ""
 };
  constructor(    
    private _userService : AssignUserRoleService,
    private _spinner : NgxSpinnerService,
    private router: Router,
    private _toastService : MessageService,
    private _httpClient : HttpClient) { }

  ngOnInit() {
    this._spinner.show();
    this.getAllUserStatus();
    this.getAllUserRole();
    this._spinner.hide();
  }

  updateStatus()
  {
    this._spinner.show();
    if(this.userWithStatus.selectedUser)
        this._userService.postUserStatus(this.userWithStatus.selectedUser);
    else
    console.log("error occurs at component while updating user status");
    this._spinner.hide();
  }

  updateRole()
  {
    this._spinner.show();
    if(this.userWithRole.selectedUser) 
        this._userService.postUserRole(this.userWithRole.selectedUser);
    else
    console.log("error occurs at component while updating user role");
    this._spinner.hide();
  }

  cancelUserUpdate()
  {
    this.router.navigate(['/home']);
  }

  getAllUserStatus() {
    let loggedIn = JSON.parse(localStorage.getItem("currentUser")).user.id;
    this._httpClient
    .get(`${environment.apiUrl}/user/user-status/${loggedIn}`).subscribe((res : any)=> {
        res = res.map(item => {
            {
                let assignUser: AssignUser = {
                    userId : guid(item.id),
                    name : item.firstName.concat(' ').concat(item.lastName),
                    firstName : item.firstName,
                    lastName : item.lastName,
                    status : item.status,
                    isActive : item.status > 0 ? true : false,
                    selectedUser : ''
                };
                return assignUser;
            }        
        });
        this.usersWithStatusList = res;
    },
      error => {
        this._toastService.add({ severity: 'error', summary: error, detail: '' });
      });


  }

  getAllUserRole() {

    let loggedIn = JSON.parse(localStorage.getItem("currentUser")).user.id;
      this._httpClient
      .get(`${environment.apiUrl}/user/user-role/${loggedIn}`).subscribe((res : any)=> {
          res = res.map(item => {
              {
                let assignUser: AssignUser = {
                  userId : guid(item.id),
                  name : item.firstName.concat(' ').concat(item.lastName),
                  roleId : item.role && item.role.id > 0 && item.role.id < 5 ? item.role.id : undefined ,
                  isActive : true,
                  firstName : item.firstName,
                  lastName : item.lastName,
                  selectedUser : ''
              };
              return assignUser;
              }        
          });
          this.usersWithRoleList = res;
      },
        error => {
          this._toastService.add({ severity: 'error', summary: error, detail: 'Error occurred while fetching users role' });
        });
  }

}
